import { createReduxSlice } from '../../ReduxSlice'
import { State } from 'app/types/redux-types'
import { BaseConfig, getBaseConfig } from './base-config-async'

const initialState: State<BaseConfig> = {
  data: {} as BaseConfig,
  status: 'idle',
  error: null
}

const baseConfigSlice = createReduxSlice({
  name: 'baseConfig',
  initialState,
  asyncThunks: {
    fetchBaseConfigData: getBaseConfig
  }
})

export const { fetchBaseConfigData } = baseConfigSlice.actions
export default baseConfigSlice.reducer
